import React from "react";
import { Button, Dropdown, Input } from "semantic-ui-react";
import DateTextBox from "react-lib/apps/common/DateTextBox";

type MeHealthPaymentHistoryFilterProps = {
  filterOrderNo: string;
  onFilterOrderNoChange: (value: string) => void;
  selectedPackage: string;
  onPackageChange: (value: string) => void;
  packageOptions: { key: string; value: string; text: string }[];
  searchDateFrom: string;
  onSearchDateFromChange: (date: any) => void;
  searchDateTo: string;
  onSearchDateToChange: (date: any) => void;
  isSearching: boolean;
  onSearch: () => void;
  primaryColor: string;
};

const MeHealthPaymentHistoryFilter = (props: MeHealthPaymentHistoryFilterProps) => (
  <div
    style={{
      display: "flex",
      gap: "10px",
      marginBottom: "1rem",
      alignItems: "center",
      marginTop: "40px",
    }}
  >
    <Input
      icon={{ name: "search", circular: false, link: false }}
      placeholder="Search Order No"
      value={props.filterOrderNo}
      onChange={(e) => props.onFilterOrderNoChange(e.target.value)}
      style={{ minWidth: "250px" }}
    />
    <span>Package</span>
    <Dropdown
      search
      selection
      placeholder="--เลือกตัวเลือก--"
      options={props.packageOptions}
      style={{ width: "500px" }}
      value={props.selectedPackage}
      onChange={(e, { value }: any) => props.onPackageChange(value)}
    />
    <span style={{ minWidth: "80px" }}>Payout Date</span>
    <DateTextBox
      value={props.searchDateFrom}
      onChange={(date: any) => props.onSearchDateFromChange(date)}
      inputStyle={{ width: "150px" }}
      setLanguage={"th"}
      placeholder="DD/MM/YYYY"
    />
    <DateTextBox
      value={props.searchDateTo}
      onChange={(date: any) => props.onSearchDateToChange(date)}
      inputStyle={{ width: "150px" }}
      setLanguage={"th"}
      placeholder="DD/MM/YYYY"
    />
    <Button
      style={{
        backgroundColor: props.primaryColor,
        color: "white",
        marginLeft: "20px",
        width: "150px",
      }}
      loading={props.isSearching}
      onClick={props.onSearch}
    >
      ค้นหา
    </Button>
  </div>
);

export default MeHealthPaymentHistoryFilter;
